import log from 'salvo-lite/log'

class ChangeAttr {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.getAttribute('data-change-attr'))
        this._triggerElem = this._data.elem
        this._attr = this._data.attr
        this._value = this._data.value || false
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('click', () => {
            const trigger = this.getTrigger()
            trigger.setAttribute(this._attr, this._value)
        })
    }

    getTrigger () {
        let trigger
        if (this._triggerElem === 'parent') {
            trigger = this._elem.parentNode
        } else if (this._triggerElem === 'self') {
            trigger = this._elem
        } else if (this._triggerElem === 'prev') {
            trigger = this._elem.previousElementSibling
        } else if (this._triggerElem === 'next') {
            trigger = this._elem.nextElementSibling
        } else {
            trigger = document.querySelector(this._triggerElem)
        }
        return trigger
    }
}

export default ChangeAttr



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ChangeAttr.js